import {useContext} from 'react';
import {Main, FeaturesContext} from 'app/components/entities/cloud';

export function useFeature(feature: Main.Feature) {
  const features = useContext(FeaturesContext);
  return features.has(feature);
}
